import styled from "styled-components";
import { colors } from "colors";

export const ImpersonateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${colors.goodBlack};
  form {
    max-width: 500px;
    padding-top: 20%;
    
  }
`;
